// @flow

import React from 'react';

type Props = {
  kpiValue: any,
  isFocus: boolean,
  isPositive?: boolean,
}

function RoiKpi({ kpiValue, isFocus, isPositive }: Props) {
  const getFocusClassname = () => {
    if (isFocus) {
      return ` roi-kpi--focus-${isPositive ? 'positive' : 'negative'}`;
    }
    return '';
  }

  return (
    <div className={`roi-kpi${getFocusClassname()}`}>
      <div className="roi-kpi-value">{kpiValue}</div>
    </div>
  );
}

export default RoiKpi;
